import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getPayrollSettingExcelItems, getStorageSalaryItem, setStorageSalaryItem } from '@/api/payroll';
import { buildTreeFromItemsResponse, buildSavePayload } from '../utils/salaryStorageTreeUtils.mjs';
export default {
  name: 'SalaryStorageSettingDialog',
  props: {
    // relation_id 实际上是后端 set/get 使用的 sub_project_id
    relation_id: {
      type: [String, Number],
      required: true
    },
    settlement_type: {
      type: [String, Number],
      required: true
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      saving: false,
      filterText: '',
      treeData: [],
      treeProps: {
        label: 'txt',
        children: 'children'
      },
      leafColumnKeys: [],
      checkAll: false,
      isIndeterminate: false
    };
  },
  watch: {
    filterText: function filterText(val) {
      // el-tree filter 依赖 mounted 后的 ref
      if (this.$refs.tree) this.$refs.tree.filter(val);
    }
  },
  mounted: function mounted() {
    this.dialogVisible = true;
    this.load();
  },
  methods: {
    handleFilterNode: function handleFilterNode(value, data) {
      var _data$txt;
      if (!value) return true;
      return String((_data$txt = data === null || data === void 0 ? void 0 : data.txt) !== null && _data$txt !== void 0 ? _data$txt : '').indexOf(value) !== -1;
    },
    load: function load() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _treeRes$data, _storageRes$data, treeRes, items, _buildTreeFromItemsRe, treeData, leafColumnKeys, storageRes, selectedLeafKeys;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              _context.prev = 1;
              _context.next = 4;
              return getPayrollSettingExcelItems({
                relation_id: _this.relation_id,
                settlement_type: _this.settlement_type,
                relation_type: 0
              });
            case 4:
              treeRes = _context.sent;
              items = (treeRes === null || treeRes === void 0 || (_treeRes$data = treeRes.data) === null || _treeRes$data === void 0 ? void 0 : _treeRes$data.items) || {};
              _buildTreeFromItemsRe = buildTreeFromItemsResponse(items), treeData = _buildTreeFromItemsRe.treeData, leafColumnKeys = _buildTreeFromItemsRe.leafColumnKeys;
              _this.treeData = treeData;
              _this.leafColumnKeys = leafColumnKeys;
              _context.next = 11;
              return getStorageSalaryItem({
                sub_project_id: _this.relation_id
              });
            case 11:
              storageRes = _context.sent;
              selectedLeafKeys = (storageRes === null || storageRes === void 0 || (_storageRes$data = storageRes.data) === null || _storageRes$data === void 0 ? void 0 : _storageRes$data.item_keys) || [];
              _this.$nextTick(function () {
                if (!_this.$refs.tree) return;
                // 有已保存的 item_keys 则回显，否则默认全选所有叶子
                var keys = selectedLeafKeys.length ? selectedLeafKeys : _this.leafColumnKeys;
                _this.$refs.tree.setCheckedKeys(keys);
                _this.syncAllCheckboxState();
              });
            case 14:
              _context.prev = 14;
              _this.loading = false;
              return _context.finish(14);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1,, 14, 17]]);
      }))();
    },
    syncAllCheckboxState: function syncAllCheckboxState() {
      if (!this.$refs.tree) return;
      var checkedLeafKeys = this.$refs.tree.getCheckedKeys(true, false);
      this.checkAll = checkedLeafKeys.length === this.leafColumnKeys.length && this.leafColumnKeys.length > 0;
      this.isIndeterminate = checkedLeafKeys.length > 0 && checkedLeafKeys.length < this.leafColumnKeys.length;
    },
    handleTreeCheck: function handleTreeCheck() {
      this.syncAllCheckboxState();
    },
    handleCheckAllChange: function handleCheckAllChange(checked) {
      if (!this.$refs.tree) return;
      if (checked) {
        this.$refs.tree.setCheckedKeys(this.leafColumnKeys);
      } else {
        // 这俩是默认勾选并置灰的
        this.$refs.tree.setCheckedKeys(['staff_name', 'total_net_pay']);
      }
      this.syncAllCheckboxState();
    },
    handleSave: function handleSave() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var selectedLeafKeys, payload, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this2.saving) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _this2.saving = true;
              _context2.prev = 3;
              if (_this2.$refs.tree) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return");
            case 6:
              selectedLeafKeys = _this2.$refs.tree.getCheckedKeys(true, false);
              payload = buildSavePayload(_this2.relation_id, selectedLeafKeys);
              _context2.next = 10;
              return setStorageSalaryItem(payload);
            case 10:
              res = _context2.sent;
              if (res && res.code === 1) {
                _this2.$message.success(res.message || _this2.$t('submit_btn'));
                _this2.$emit('saved');
                _this2.$emit('close');
              }
            case 12:
              _context2.prev = 12;
              _this2.saving = false;
              return _context2.finish(12);
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[3,, 12, 15]]);
      }))();
    },
    handleClose: function handleClose() {
      // 组件通过 v-if 控制销毁，所以只需通知父组件关闭
      this.dialogVisible = false;
      this.$emit('close');
    }
  }
};